import ViewBase from "../../../../framework/core/mvvm/view_base";
import ScrollControl from "./scrollcontrol";
import CurtomerTimeManager from "./curtomer_time_manager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class CustomerServiceView extends ViewBase {

    @property(ScrollControl)
    scrollControl: ScrollControl = null;

    @property(cc.Button)
    sendBtn:cc.Button = null;
    

    @property(cc.Button)
    closeBtn:cc.Button = null;

    @property(cc.EditBox)
    inputTxt:cc.EditBox = null;


    @property(CurtomerTimeManager)
    timeMgr:CurtomerTimeManager = null;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        
    }
    
    // update (dt) {}
}
